export default "__VITE_ASSET__y$o7Kajh__"